import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";

@Injectable({
  providedIn: "root",
})
export class LandingPropertyService {
  private baseUrl = environment.API_URL_LANDING;

  constructor(private http: HttpClient) {}

  setValoracion(data: any): Promise<any[]> {
    return this.http.post<any[]>(`${this.baseUrl}rating-property`, data).toPromise();
  }
}
